import React from "react";
import "./ConfirmModal.css";
import ReusableButton from "../reusable-button/ReusableButton";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">{title}</h2>
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          {/* <ReusableButton label={cancelText} onClick={onCancel} variant="outlined" /> */}
          <ReusableButton
            label={cancelText}
            onClick={onCancel}
            variant="outlined"
          />
          <ReusableButton
            label={confirmText}
            onClick={onConfirm}
            variant="primary"
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
